import { paymentsService } from "../../../services/payments";
import { useAct } from "../../../shared/hooks/useAct";
import { getAllEntries } from "../../../utils/serviceHelper";
import { useModalBulkOpen } from "../../components/NewPayablesTable/ModalBulkOpen";
import { API_QUERY_PAYABLES_DRAFT } from "./apiQueries";

export function useOpenAll() {
  const modalBulkOpen = useModalBulkOpen();

  return useAct(async () => {
    const payables = await getAllEntries(async (...args) => {
      return (await paymentsService.payable.list(...(args as any))).data;
    }, API_QUERY_PAYABLES_DRAFT.filter);

    await modalBulkOpen.open({
      data: payables.map(payable => ({ payable }))
    });
  });
}
